export const ESI_PATIENT_UPDATE_PREFERENCES_WEEKLY_REPORTS = 'esi-patient-update-preferences-weekly-reports';
export const ESI_PATIENT_UPDATE_PREFERENCES_SCHEDULED_REMINDERS = 'esi-patient-update-preferences-scheduled-reminders';
